import NewsCard from "../../Helper/NewsCard";
import SmallImagesNewsCard from "../../Helper/SmallImagesNewsCard";

const LeftComponent = ({ leftSideData = [], title }) => {
  const [firstNews, ...restNews] = leftSideData;

  return (
    <section className="space-y-6">
      {/* First News Card */}
      {firstNews && (
        <NewsCard
          title={title}
          subtitle={firstNews?.title}
          imageUrl={firstNews?.thumbnail_large}
          media_details={firstNews?.media_details?.sizes}
          imageAlt={firstNews?.thumbnail_alt}
          isVideo={firstNews?.is_video}
          showDot
          dotColor="bg-orange-500"
          titleClassName="!text-[20px] !leading-[22px]"
          imageClassName="h-64 md:h-80 lg:h-96"
          href={firstNews?.permalink}
          loading="lazy"
          decoding="async"
        />
      )}

      {/* Remaining News List */}
      <div className="grid lg:grid-cols-2 gap-6">
        {restNews.map((item, index) => (
          <div className="space-y-5" key={item.id || index}>
            <SmallImagesNewsCard
              subtitle={item?.title}
              image={item?.thumbnail}
              // media_details={item?.media_details?.sizes}
              href={item?.permalink}
              isVideo={item?.is_video}
              imageAlt={item?.thumbnail_alt}
              subtitleAs="h2"
              subtitleProps={{
                size: "16px",
                lineHeight: "22px",
                className: "cursor-pointer",
              }}
              loading="lazy"
              fetchPriority="low"
              decoding="async"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default LeftComponent;
